import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import { useImaginationRoom } from '@invitato/imagination-room';

import { THE_BRIDE } from '@/constants';
import { BG_DESKTOP_VIEW } from '@/constants/assets';
import { BG_SECONDARY } from '@/constants/colors';
import { TEXT_PROPS } from '@/constants/default-props';
import WithAnimation from '@/components/Common/WithAnimation';

function LeftContent() {
  const { onGetFinalContent, onGetFinalName } = useImaginationRoom();

  return (
    <Box
      background={`url(${onGetFinalContent('BG_DESKTOP_VIEW', BG_DESKTOP_VIEW)})`}
      bgSize="cover"
      bgPosition="bottom"
      position="relative"
      width="calc(100% - 500px)"
      pos="fixed"
      borderRight="8px solid"
      borderRightColor="blackAlpha.400"
      height="100%"
      zIndex="1"
    >
      <Box
        padding="24px 42px"
        height="100%"
        bgImage={`linear-gradient(to bottom right, ${BG_SECONDARY}, transparent 40%)`}
      >
        <WithAnimation>
          <Text
            {...TEXT_PROPS.body}
            fontSize="24px"
            color="alternativeColorText"
            paddingTop="24px"
            textAlign="center"
            fontWeight={'bold'}
          >
            The Wedding of
          </Text>
        </WithAnimation>
        <WithAnimation>
          <Text
            margin="16px 0 32px 0"
            {...TEXT_PROPS.subHeading}
            color="alternativeColorText"
            fontSize="60px"
            textAlign="center"
            fontWeight="bold"
            dangerouslySetInnerHTML={{
              __html: onGetFinalName('coupleName', THE_BRIDE)
            }}
          />
        </WithAnimation>
      </Box>
    </Box>
  );
}

export default LeftContent;
